<div class="start-page">
  <div class="content">
    <div class="logo-wrapper">
      <img src="assets/img/logo/logo-light.svg" alt="Nobina logo" class="nobina-logo" />
    </div>

    <div class="welcome" i18n='@@login.welcome'>Välkommen till Nobinas realtidsplattform för trafikuppdrag</div>

    <button class="btn btn-primary login-btn" (click)="login()">
      <span i18n='@@login.login'>Logga in</span>
    </button>
  </div>
</div>
